// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sharedPrintStyles } from "@keller/App/Components/Common/SharedPrintStyles";
import { billingAndShippingAddressStyles } from "@keller/Overrides/Widgets/CheckoutReviewAndSubmit/BillingAndShippingInfo";
import { hideElementOnPrint } from "@keller/XDL/Utilities";
import { css } from "styled-components";

billingAndShippingAddressStyles.mainContainer = {
    ...sharedPrintStyles.mainContainer,
};

billingAndShippingAddressStyles.addressGridWrapper = {
    ...sharedPrintStyles.addressGridWrapper,
};

billingAndShippingAddressStyles.container = {
    ...sharedPrintStyles.container,
};

billingAndShippingAddressStyles.billingAddressGridItem = {
    ...sharedPrintStyles.billingAddressGridItem,
};

billingAndShippingAddressStyles.shippingAddressGridItem = {
    ...sharedPrintStyles.shippingAddressGridItem,
};

billingAndShippingAddressStyles.orderConfirmationTotalGridItem = {
    ...sharedPrintStyles.orderConfirmationTotalGridItem,
};

billingAndShippingAddressStyles.notesGridItem = {
    ...sharedPrintStyles.notesGridItem,
};

billingAndShippingAddressStyles.hideOnPrint = {
    ...sharedPrintStyles.hideOnPrint,
};

billingAndShippingAddressStyles.labelName = {
    headingTextGridItem: {
        css: css`
            ${hideElementOnPrint}
        `,
    },
};

billingAndShippingAddressStyles.richContentOnPrintGridItem = {
    ...sharedPrintStyles.richContentOnPrintGridItem,
};
